import { render } from "./Info.vue?vue&type=template&id=f0deed2a&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=f0deed2a&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0deed2a"]])

export default __exports__